// Core
import React, { Component } from 'react';

// Components
import {
    GECKO_CONSTS,
    GeckoFields,
    GeckoBtnsSorted, 
    GeckoModalService,
    GeckoDialogService,
    GeckoToastService,
} from '@geckolabs/gecko-react-ui';

import { Post } from '../../../../services/ApiRequest';

const changeWeeklySmsCostLimit = (routing_id, max_sms_spend, max_sms_spend_days, updateMaxSmsSpend) => {
    //console.log(account_uuid, max_sms_spend, max_sms_spend_days);
    return new GeckoDialogService().confirm('Are you sure you want to change the weekly SMS cost limit?').then(ok => {
        if (ok) {
            return Post(`/accounts/${routing_id}`, {max_sms_spend, max_sms_spend_days }).then(res => {
                updateMaxSmsSpend(max_sms_spend);
                new GeckoToastService().success('Weekly SMS cost limit updated successfully');
            }).catch(err => {
                new GeckoToastService().error('Failed to update weekly SMS cost limit');
            });
        }
    });
}

export default class WeeklySmsCostLimit extends Component {

    constructor(props) {
        super();

        this.state = {
            routing_id: props.routing_id,
            max_sms_spend: props.max_sms_spend,
            max_sms_spend_days: props.max_sms_spend_days,
            sms_spend_in_period: props.sms_spend_in_period,
            updateMaxSmsSpend: props.updateMaxSmsSpend,
        }
    }

    fields = [
        {
            key: 'max_sms_spend',
            val: null,
            label: 'SMS Cost Limit (in GBP)',
            type: GECKO_CONSTS.FIELD_TYPE_NUMBER,
            required: true,
            width: '100%',
        },
        {
            key: 'max_sms_spend_days',
            val: null,
            label: 'SMS Cost Limit Period (in Days)',
            type: GECKO_CONSTS.FIELD_TYPE_NUMBER,
            required: true,
            width: '100%',
            disabledWhen: () => true,
        }
    ];

    modalButtons = [
        {
            name: 'Cancel',
            preset: GECKO_CONSTS.BTN_PRESET_CLOSE,
            handler: () => {
                return new GeckoModalService().close();
            },
        },
        {
            name: 'Save',
            preset: GECKO_CONSTS.BTN_PRESET_SAVE,
            disabledWhen: () => !this.state.max_sms_spend || !this.state.max_sms_spend_days,
            handler: () => changeWeeklySmsCostLimit(this.state.routing_id, this.state.max_sms_spend, this.state.max_sms_spend_days, this.state.updateMaxSmsSpend).then(() => {
                new GeckoModalService().close();
            })
        }
    ];

    handleChange(key, val) {
        this.setState({
            [key]: val,
        });
    }

    render() {
        return (
            <div>
                <div className="col-12">
                    <div className=" alert alert-info">
                        This account has spent <span className="font-weight-bold">£{parseFloat(this.state.sms_spend_in_period).toFixed(2)}</span> on SMS in the last {this.state.max_sms_spend_days} days.
                    </div>
                </div>
                <GeckoFields fields={this.fields} values={this.state} handler={this.handleChange.bind(this)} />
                
                <div className="modal-footer">
                    <GeckoBtnsSorted items={this.modalButtons} />
                </div>
            </div>
        );
    }
}
